import { render, staticRenderFns } from "./Imunitate.vue?vue&type=template&id=00f849a3&"
import script from "./Imunitate.vue?vue&type=script&lang=js&"
export * from "./Imunitate.vue?vue&type=script&lang=js&"
import style0 from "./Imunitate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Imunitate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports